/**
 * @param {string} raw
 * @param {string} [baseOrigin] — SSR için örn. `${proto}://${host}` (window yokken göreli path için)
 */
export function toAbsoluteMediaUrl (raw, baseOrigin = '') {
  const s = raw != null ? String(raw).trim() : '';
  if (!s) {
    return '';
  }
  if ((/^https?:\/\//i).test(s)) {
    return s;
  }
  if ((/^\/\//).test(s)) {
    return `https:${s}`;
  }
  const origin = typeof window !== 'undefined' && window.location?.origin
    ? window.location.origin
    : String(baseOrigin || '').replace((/\/$/), '');
  if (!origin) {
    return s;
  }
  const path = s.startsWith('/') ? s : `/${s}`;
  return `${origin}${path}`;
}
